import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { PipeEnum } from 'src/app/shared/helpers/constants';
import { IColumnsDataTable } from '../../Entities/entities';

@Directive({
  selector: '[appTableFooterFormat]',
})
export class TableFooterFormatDirective implements OnInit {
  @Input() column: IColumnsDataTable;
  @Input() value: any;

  private el: HTMLTableDataCellElement;

  constructor(elRef: ElementRef, private renderer: Renderer2) {
    this.el = elRef.nativeElement;
  }

  ngOnInit() {
    if (this.column.Icon) {
      this.renderer.addClass(this.el, 'mat-cell-center');
    } else {
      switch (this.column.Pipe) {
        case PipeEnum.currencyCLPipe:
          this.renderer.addClass(this.el, 'mat-cell-right');
          break;
        case PipeEnum.UFPipe:
        case PipeEnum.decimalPipe:
        case PipeEnum.thousandPipe:
          this.renderer.addClass(this.el, 'mat-cell-right');
          break;
        case PipeEnum.percentagePipe:
          this.renderer.addClass(this.el, 'mat-cell-right');
          break;
        case PipeEnum.purePercentagePipe:
          this.renderer.addClass(this.el, 'mat-cell-right');
          break;
        default:
          this.renderer.addClass(this.el, 'mat-cell-left');
          break;
      }
    }
  }
}
